export default {
    state: {
        units: [],
        unit: [],
        errors: {},
        unit_id: null,
        form: {
            name: '',
            floor_id: '',
            registered_at: null,
        },
        status_form: {},
        meta: {
            current_page: 1,
            per_page: "10",
            total: 0,
            from: '',
            to: '',
            sort: 'desc',
            order_by: 'Choose',
            sort_by: 'created_at',
            sort_desc: true,
            search: '',
            page_sizes: [10, 25, 50, 100],
        },
        table: {
            fields: [
                {key: 'id', label: 'Code', sortable: true},
                {key: 'name', label: 'Name', sortable: true},
                {key: 'floor', label: 'Floor', tdClass: 'text-muted'},
                {key: 'facility', label: 'Facility', tdClass: 'text-muted'},
                {key: 'type', label: 'Type', tdClass: 'text-muted'},
                {key: 'vacant_from', label: 'Vacant From', tdClass: 'text-muted'},
                {key: 'vacant', label: 'Status', sortable: true, thClass: 'text-center', tdClass: 'text-center'},
                {key: 'active', label: 'Operative', sortable: true, thClass: 'text-center', tdClass: 'text-center'},
                {key: 'actions', label: 'Actions', thClass: 'text-center', tdClass: 'text-center'},
            ]
        },
        url: '/api/hms/locations/units',
    },

    getters: {
        getUnitTableFields: state => state.table.fields,

        getUnitsMeta: state => state.meta,

        getUnitForm: state => state.form,

        getUnitErrors: state => state.errors,

        getUnitStatusForm: state => state.status_form,
    },

    mutations: {
        resetUnitsMeta: state => {
            state.meta = {
                current_page: 1,
                per_page: 10,
                total: 0,
                from: '',
                to: '',
                sort: 'desc',
                order_by: 'Choose',
                sort_by: 'created_at',
                sort_desc: true,
                search: '',
                page_sizes: [10, 25, 50, 100],
            };
        },

        setUnits: (state, payload) => {
            state.units = payload;
        },

        setUnit: (state, payload) => {
            state.unit = payload;
        },

        setUnitsMeta: (state, payload) => {
            state.meta = {...state.meta, ...payload};
        },

        setUnitErrors: (state, payload) => {
            state.errors = payload;
        },

        setUnitForm: state => {
            state.form = {
                name: '',
                floor_id: '',
                registered_at: null,
            };

            state.errors = {};
        },

        setUnitStatusForm: state => {
            state.status_form = {
                active: state.unit.data.attributes.active === 'Active',
                unit_id: state.unit.unit_id,
            };

            state.errors = {};
        },
    },

    actions: {
        fetchUnits: ({state, commit}) => {
            let parameters = {
                page: state.meta.current_page,
                per_page: state.meta.per_page,
                sort_by: state.meta.sort_by,
                sort: state.meta.sort,
                search: state.meta.search,
            };



            if (!parameters.search && parameters.search.length <= 3) {
                delete parameters.search;
            }

            return new Promise((resolve, reject) => {
                axios.get(state.url+'?state', {params: parameters})
                    .then(response => {
                        commit('setUnits', response.data);

                        commit('setUnitsMeta', response.data.meta);

                        resolve(response.data);
                    })
                    .catch(error => {
                        commit('setUnitErrors', error.response.data.errors);

                        reject();
                    });
            });
        },

        fetchUnit: ({state, commit}, unit_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + unit_id)
                    .then(response => {
                        commit('setUnit', response.data);
                        commit('setUnitStatusForm', response.data);

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        submitUnit: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.post(state.url, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        if (error.response.data.errors) {
                            commit('setUnitErrors', error.response.data.errors);
                        }

                        reject(error);
                    });
            })
        },

        updateUnit: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.patch(state.url + '/' + state.unit_id, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        if (error.response.data.errors) {
                            commit('setUnitErrors', error.response.data.errors);
                        }

                        reject(error);
                    });
            })
        },

        fetchEditUnit: ({state, commit}, unit_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + unit_id + '/edit')
                    .then(response => {
                        state.unit_id = response.data.id;

                        state.form = response.data;

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        deleteUnit: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.delete(state.url + '/' + payload.unit_id)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            })
        },

        submitUnitStatus: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.patch(state.url + '/' + payload.unit_id + '/status', payload.form)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        if (error.response.data.errors) {
                            commit('setUnitErrors', error.response.data.errors);
                        }

                        reject(error);
                    });
            })
        },
    }
}
